import React from 'react'

import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import Badge from '@material-ui/core/Badge'

import withStyles from '@material-ui/core/styles/withStyles'

import BlackStoneIcon from '@material-ui/icons/Lens'
import WhiteStoneIcon from '@material-ui/icons/LensOutlined'
import StarIcon from '@material-ui/icons/Star'
import green from '@material-ui/core/colors/green'

import UndoIcon from '@material-ui/icons/Undo'

import { PLAYER_TYPE, roomStatus } from '../../../constants'
import { Link } from 'react-router-dom'
import { makePath } from '../../../lib';
import { useEffect } from 'react'
import { useRef } from 'react'
import { useContext } from 'react'
import { SettingsContext } from '../../../Parts/Settings'
import { GameContext } from '../GameProvider'
import { useReducer } from 'react'
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'

const styles = theme => ({
  playerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing.unit * 2,
  },
  playerNameBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: `calc(100% - 140px)`
  },
  displayNameAndUserName: {
    width: `calc(100% - 48px)`
  },
  avatar: {
    marginRight: theme.spacing.unit,
  },
  timeAndReadyBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  time: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey[700],
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    borderRadius: theme.spacing.unit,
  },
  ready: {
    width: 24,
    height: 24,
    boxSizing: 'border-box',
    backgroundColor: green[500],
    color: theme.palette.common.white,
    marginRight: theme.spacing.unit / 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 12,
  },
  userNameBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  connectBadgeRoot: {
    textDecoration: 'none',
  },
  connectBadge: {
    top: 'auto',
    bottom: -6,
    right: 0,
  },
  connect: {
    width: theme.spacing.unit,
    height: theme.spacing.unit,
    backgroundColor: green[500],
    border: `1px solid ${theme.palette.common.white}`
  },
  disconnect: {
    width: theme.spacing.unit,
    height: theme.spacing.unit,
    backgroundColor: theme.palette.grey[500],
    border: `1px solid ${theme.palette.common.white}`
  },
  stoneIcon: {
    color: theme.palette.grey[800],
    width: 10,
    height: 10,
    marginRight: theme.spacing.unit / 2,
  },
  ownerIcon: {
    color: theme.palette.grey[800],
    width: 10,
    height: 10,
    marginLeft: theme.spacing.unit / 2,
  },
  draw: {
    width: 24,
    height: 24,
    boxSizing: 'border-box',
    backgroundColor: green[500],
    color: 'white',
    marginRight: theme.spacing.unit / 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
  },
  undo: {
    width: 24,
    height: 24,
    boxSizing: 'border-box',
    backgroundColor: green[500],
    color: 'white',
    marginRight: theme.spacing.unit / 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  undoIcon: {
    fontSize: 12,
  }
})


const initialState = {
  time: 0,
  timeoutIDs: [],
  timeLimit: undefined
}

const ACTION = {
  UPDATE_TIME: 'UPDATE_TIME',
  ADD_TIMEOUT_ID: 'ADD_TIMEOUT_ID',
  CLEAR_TIMEOUT_ID: 'CEAR_TIMEOUT_ID',
  UPDATE_TIME_LIMIT: 'UPDATE_TIME_LIMIT',
  CLEAR_TIME_LIMIT: 'CLEAR_TIME_LIMIT',
}

const reducer = (state, action)=> {
    switch (action.type){
      case ACTION.UPDATE_TIME:
        return {
          ...state,
          time: Date.now()
        }
      case ACTION.ADD_TIMEOUT_ID:
        return {
          ...state,
          timeoutIDs: state.timeoutIDs.concat(action.timeoutID)
        }
      case ACTION.CLEAR_TIMEOUT_ID:
        return {
          ...state,
          timeoutIDs: []
        }
      case ACTION.UPDATE_TIME_LIMIT:
        return {
          ...state,
          timeLimit: {
            minute: action.minute,
            second: action.second
          }
        }
      case ACTION.CLEAR_TIME_LIMIT:
        return {
          ...state,
          timeLimit: undefined
        }
      default:
        return state
    }
  }

const PlayerBox = withStyles(styles, { withTheme: true })((props) => {
  const { classes, type } = props
  var isConnected, swapCount, color, black, white, ownerIcon

  const [state, dispatch] = useReducer(reducer, initialState)

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const gameContext = useContext(GameContext)

  const player = gameContext.room ? 
    type === PLAYER_TYPE.PLAYER_1 ? gameContext.room.player1 :
    type === PLAYER_TYPE.PLAYER_2 ? gameContext.room.player2 :
    undefined : undefined

  var prevRoom = useRef(gameContext.room)

  useEffect(() => {
    var remainTime

    if (gameContext.room === undefined) {
      return
    }

    if (
      prevRoom.current.status !== roomStatus.PLAYING &&
      gameContext.room.status === roomStatus.PLAYING
    ) {
      updateTimeLimit()
    }
    else if (
      (gameContext.room.status === roomStatus.WAIT || gameContext.room.status === roomStatus.EMPTY) &&
      prevRoom.current.status === roomStatus.END
    ) {
      state.timeoutIDs.forEach(id => clearTimeout(id))
      dispatch({ type: ACTION.CLEAR_TIMEOUT_ID })
      dispatch({ type: ACTION.CLEAR_TIME_LIMIT })
    }

    if (
      gameContext.room.status === roomStatus.PLAYING &&
      gameContext.room.turn !== undefined && player !== undefined && player.userName !== undefined
    ) {
      remainTime = calcRemainTime(gameContext.room, player, Date.now(), gameContext.diffTime)
      if (gameContext.room.turn.userName === player.userName) {
        if (remainTime >= 0) {
          if (
            gameContext.room.turn.userName === player.userName &&
            state.timeoutIDs.length === 0
          ) {
            let timeout = setTimeout(() => dispatch({ type: ACTION.UPDATE_TIME }), remainTime % 1000)
            dispatch({ type: ACTION.ADD_TIMEOUT_ID, timeoutID: timeout })
          }
          dispatch({
            type: ACTION.UPDATE_TIME_LIMIT,
            minute: remainTime > 0 ? parseInt(remainTime / 60000, 10) : 0,
            second: remainTime > 0 ? parseInt(remainTime % 60000 / 1000, 10) : 0
          })
        }
      }
      else {
        state.timeoutIDs.forEach(id => clearTimeout(id))
        dispatch({ type: ACTION.CLEAR_TIMEOUT_ID })
        if (
          gameContext.room.moves && prevRoom.current.moves &&
          gameContext.room.moves.length > 1 && gameContext.room.moves.length > prevRoom.current.moves.length &&
          remainTime >= 0
        ) {
          dispatch({
            type: ACTION.UPDATE_TIME_LIMIT,
            minute: remainTime > 0 ? parseInt(remainTime / 60000, 10) : 0,
            second: remainTime > 0 ? parseInt(remainTime % 60000 / 1000, 10) : 0
          })
        }
      }
    }
    prevRoom.current = gameContext.room
  }, [gameContext.room])

  useEffect(() => {
    updateTimeLimit()
  }, [state.time])

  const updateTimeLimit = () => {
    var remainTime, timeout

    if (
      gameContext.room.status !== roomStatus.PLAYING ||
      gameContext.room === undefined ||
      player === undefined
    ) {
      return
    }
    remainTime = calcRemainTime(gameContext.room, player, Date.now(), gameContext.diffTime)
    if (
      gameContext.room.status === roomStatus.PLAYING &&
      gameContext.room.turn !== undefined && player !== undefined &&
      gameContext.room.turn.userName === player.userName &&
      remainTime >= 0
    ) {
      state.timeoutIDs.forEach(id => clearTimeout(id))
      timeout = setTimeout(() => dispatch({ type: ACTION.UPDATE_TIME }), remainTime % 1000)
      dispatch({ type: ACTION.ADD_TIMEOUT_ID, timeoutID: timeout })
    }
    dispatch({
      type: ACTION.UPDATE_TIME_LIMIT,
      minute: remainTime > 0 ? parseInt(remainTime / 60000, 10) : 0,
      second: remainTime > 0 ? parseInt(remainTime % 60000 / 1000, 10) : 0
    })
  }

  const calcRemainTime = (room, targetPlayer, now, diffTime) => {
    var mineTime, totalIncreaseSecond, beforeDatetime, remainTime
    mineTime = 0
    totalIncreaseSecond = 0
    room.moves.forEach((move, index) => {
      if (index === 0) {
        beforeDatetime = move.datetime
        return
      }
      if (move.player.userName === targetPlayer.userName) {
        mineTime += move.datetime - beforeDatetime
      }
      beforeDatetime = move.datetime

      if (
        (
          index < room.moves.length - 1 &&
          move.player.userName === targetPlayer.userName && 
          room.moves[index + 1].player.userName !== targetPlayer.userName
        ) ||
        (
          index === room.moves.length - 1 &&
          move.player.userName === targetPlayer.userName &&
          room.turn.userName !== targetPlayer.userName
        )
      ) {
        totalIncreaseSecond += room.increaseSecond * 1000
      }
    })
    if (room.turn.userName === targetPlayer.userName) {
      mineTime += now + diffTime - room.moves[room.moves.length - 1].datetime
    }

    remainTime = Boolean(
      room.turn.userName !== targetPlayer.userName &&
      room.moves.every((mv, index) => 
        index === 0 || mv.player.userName !== targetPlayer.userName
      )
    ) ?
      room.minute * 60 * 1000 :
      room.minute * 60 * 1000 + totalIncreaseSecond - mineTime
      
    return remainTime
  }

  if (player === undefined) {
    return (
      <div className={classes.playerBox}>
        <div className={classes.playerNameBox}>
          <Avatar className={classes.avatar}>
            <div></div>
          </Avatar>
        </div>
        <Typography variant='title' className={classes.time}>
          {gameContext.room.minute === undefined ? '00:00' : (('00' + gameContext.room.minute).slice(-2) + ':00')}
        </Typography>
      </div>
    )
  }
  else {
    if (gameContext.room.status === roomStatus.PLAYING) {
      swapCount = gameContext.room.moves.filter(mv => mv.swap === true).length
      black = (<BlackStoneIcon className={classes.stoneIcon}/>)
      white = (<WhiteStoneIcon className={classes.stoneIcon}/>)
      color = player.color === 'black' ? (swapCount % 2 === 0 ? black : white) :
              player.color === 'white' ? (swapCount % 2 === 0 ? white : black) : undefined
    }
    isConnected = Boolean(undefined !== gameContext.room.users.find(user => user.userName === player.userName))
    ownerIcon = gameContext.room.owner !== undefined && gameContext.room.owner.userName === player.userName ?
      (<StarIcon className={classes.ownerIcon}/>) : undefined
    return (
      <div className={classes.playerBox}>
        <div className={classes.playerNameBox}>
          <Badge
            key={player.userName}
            classes={{
              root: classes.connectBadgeRoot,
              badge: classes.connectBadge
            }}
            badgeContent={isConnected ? (<div className={classes.connect}/>) : (<div className={classes.disconnect}/>)}
            component={Link}
            to={makePath(`/user/${player.userName}`, language)}
            target={'_blank'}
          >
            <CustomAvatar
              alt={player.displayName}
              name={player.displayName}
              src={player.avatarPhotoURL}
              className={classes.avatar}
            />
          </Badge>
          <div className={classes.displayNameAndUserName}>
            <Typography noWrap>{color !== undefined && color}{player.displayName}</Typography>
            <div className={classes.userNameBox}>
              <Typography noWrap>@{player.userName}</Typography>
              {ownerIcon}
            </div>
          </div>
        </div>
        <div className={classes.timeAndReadyBox}>
          {gameContext.room.draw && gameContext.room.draw.offer === true && gameContext.room.draw.player.userName === player.userName && (
            <Typography className={classes.draw}>1/2</Typography>
          )}
          {gameContext.room.undo && gameContext.room.undo.offer === true && gameContext.room.undo.player.userName === player.userName && (
            <div className={classes.undo}>
              <UndoIcon className={classes.undoIcon} color='inherit'/>
            </div>
          )}
          {(gameContext.room.status === roomStatus.EMPTY || gameContext.room.status === roomStatus.WAIT) && player.ready === true && (
            <Typography noWrap className={classes.ready}>OK</Typography>
          )}
          <Typography variant='title' className={classes.time}>
            {state.timeLimit !== undefined ? (
              `${('00' + state.timeLimit.minute).slice(-2)}:${('00' + state.timeLimit.second).slice(-2)}`
            ) : gameContext.room.minute === undefined ? (
              '00:00'
            ) : (
              ('00' + gameContext.room.minute).slice(-2) + ':00'
            )}
          </Typography>
        </div>
      </div>
    )
  }
})

export default PlayerBox



// WEBPACK FOOTER //
// ./src/Pages/Game/components/PlayerBox.js